<template>
  <div id="app">
    <!-- 关闭应用及转发组件 -->
    <router-view :key="this.$route.path" />
  </div>
</template>
<script>
export default {
  name: '',
  props: {},
  data () {
    return {}
  },
  computed: {},
  created () { },
  mounted () { },
  watch: {},
  methods: {},
  components: {}
}
</script>
<script>
window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault()
  })
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  background-color: rgba(255, 255, 255, 1);
  font-family: PingFang;
}
.van-nav-bar {
  position: fixed;
  top: 0;
}
</style>
